import React, { useState } from 'react';
import CustomerList from '../components/CustomerList';
import CustomerForm from '../components/CustomerForm';
import useWindowWidth from '../hooks/useWindowWidth';
import '../components/RevenueDesktop.css';
import '../components/QuickCreateModal.css';

function CustomersPage() {
  const [editingCustomer, setEditingCustomer] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const width = useWindowWidth();
  const isDesktop = width >= 768;

  const handleEdit = (customer) => {
    setEditingCustomer(customer);
    setShowForm(true);
  };

  const handleNewCustomer = () => {
    setEditingCustomer(null);
    setShowForm(true);
  };

  const handleClose = () => {
    setShowForm(false);
    setEditingCustomer(null);
  };

  const handleSuccess = () => {
    handleClose();
    setRefreshTrigger(prev => prev + 1);
  };

  return (
    <div>
      {/* ── Desktop header ── */}
      {isDesktop && (
        <div className="rv-page-header">
          <div className="rv-page-header-title">
            <h1>Clientes</h1>
            <p>Gerencie seus clientes</p>
          </div>
          <button className="rv-btn rv-btn-primary" onClick={handleNewCustomer}>
            + Novo Cliente
          </button>
        </div>
      )}

      {/* ── Mobile header ── */}
      {!isDesktop && <h1>Gerenciamento de Clientes</h1>}

      {/* Lista sempre visível */}
      <CustomerList
        onEdit={handleEdit}
        refreshTrigger={refreshTrigger}
        onNewCustomer={handleNewCustomer}
      />

      {/* Modal com o formulário */}
      {showForm && (
        <div
          className="qc-overlay"
          onClick={e => { if (e.target === e.currentTarget) handleClose(); }}
        >
          <div className="qc-box qc-box--wide">
            <div className="qc-header">
              <span className="qc-title">
                {editingCustomer ? 'Editar Cliente' : 'Novo Cliente'}
              </span>
              <button type="button" className="qc-close" onClick={handleClose} aria-label="Fechar">✕</button>
            </div>
            <div className="qc-body">
              <CustomerForm customer={editingCustomer} onSuccess={handleSuccess} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default CustomersPage;
